import ThumbnailsSidebar from './thumbnailsSidebar'

export default ThumbnailsSidebar
